// frontend/src/components/PinnedArticle.js
// Displays the admin-pinned article in the top-right of the homepage.
// Stays static across page refreshes.
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './PinnedArticle.css';

const PinnedArticle = () => {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPinned();
  }, []);

  const fetchPinned = async () => {
    try {
      const res = await api.get('/admin/pinned-article');
      setArticle(res.data);
    } catch (err) {
      // 404 means no pinned article — that's fine
      setArticle(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !article) return null;

  return (
    <div className="pinned-article-widget" onClick={() => navigate(`/article/${article.id}`)}>
      <div className="pinned-article-label">
        <span className="pin-icon">📌</span>
        <span className="pin-text">Editor's Pick</span>
      </div>

      {article.image_url && (
        <img
          src={article.image_url}
          alt={article.title}
          className="pinned-article-image"
          onError={e => e.target.style.display = 'none'}
        />
      )}

      <div className="pinned-article-body">
        <span className="pinned-category-tag">
          {article.category?.toUpperCase()}
        </span>
        <h3 className="pinned-article-title">{article.title}</h3>
        <p className="pinned-article-summary">
          {article.ai_summary || article.summary || article.content?.substring(0, 120) + '...'}
        </p>
        <div className="pinned-article-meta">
          <span className="pinned-source">{article.source_name ? `${article.source_name} via FocusView.ai` : 'FocusView Editorial'}</span>
          <span className="pinned-date">
            {new Date(article.published_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
          </span>
        </div>
      </div>

      <div className="pinned-article-cta">
        Read More →
      </div>
    </div>
  );
};

export default PinnedArticle;
